import { render, staticRenderFns } from "./WhatsappLinkCard.vue?vue&type=template&id=1605dc53&scoped=true&"
import script from "./WhatsappLinkCard.vue?vue&type=script&lang=js&"
export * from "./WhatsappLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappLinkCard.vue?vue&type=style&index=0&id=1605dc53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605dc53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
